import { post } from './glosbe-dictionary-api-helper';
export function addImage(file, adult, credits) {
    const formData = new FormData();
    formData.append("adult", adult ? "true" : "false");
    formData.append("credits", credits);
    formData.append("file", file);
    return post({
        endpoint: 'image',
        formData, options: { credentials: 'include' }
    });
}
